import React from 'react';
import styled, { keyframes } from 'styled-components';
import { FaTrash, FaEllipsisV, FaUserTie } from 'react-icons/fa';
import { MdBuild } from 'react-icons/md';
import ItemOptionDropdown from './ItemOptionDropdown';
import oh from 'output-helpers';

class EntityListItem extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            admin_note_hover: false,
        };

        const anim_fade_down = keyframes`
            0% {
                opacity: 0;
                transform: translateY(-5px);
            }
            100% {
                opacity: 1;
                transform: translateY(0px);
            }
        `;

        this.container = styled.li`
            cursor: pointer;
            position: relative;
            background-color: #fff;
            display: ${props => (props.small ? 'inline-block' : 'block')};
            margin: ${props => (props.small ? '0 8px 8px 0' : '0')};
            border-radius: ${props => (props.small ? '4px' : 'unset')};
            width: ${props => (props.small ? '160px' : 'initial')};
            &:hover {
                border-color: ${props => props.theme.colors.blue[0]};
                background-color: ${props => props.theme.colors.blue[1]};
                color: #fff;
            }
            .entity_option_block {
                cursor: pointer;
                padding: 0 12px;
                border-left: 1px solid ${props => props.theme.colors.border};
                width: ${props => (props.small ? '30%' : '20%')};
                text-align: center;
                opacity: 0.8;
                &:hover {
                    opacity: 1;
                }
            }

            .entity_info_block,
            .entity_option_block {
                display: inline-block;
                vertical-align: middle;
            }
            .entity_completed_block {
                position: absolute;
                top: 0;
                left: 0;
                bottom: -1px;
                border-bottom: 1px solid rgba(0, 0, 0, 0.2);
                width: 12px;
                background-color: ${props => props.theme.colors.gray[2]};
                &.completed_true {
                    background-color: ${props => props.theme.colors.green[2]};
                }
                &.completed_false {
                    background-color: ${props => props.theme.colors.red[2]};
                }
            }
            .entity_info_block {
                width: ${props =>
                    props.renderOption
                        ? props.small
                            ? '70%'
                            : '80%'
                        : '100%'};
                padding: ${props => (props.small ? '8px 16px' : '14px 20px')};
                position: relative;
                .note_hover {
                    animation: ${anim_fade_down} 0.3s;
                    z-index: 2;
                    border-radius: 4px;
                    font-size: 12px;
                    position: absolute;
                    left: 12px;
                    top: 32px;
                    white-space: pre-line;
                    width: 200px;
                    background-color: ${props => props.theme.colors.dark[0]};
                    color: #fff;
                    padding: 8px;
                    pointer-events: none;
                    .note_hover_title {
                        font-size: 14px;
                        font-weight: bold;
                        margin-bottom: 2px;
                    }
                }
            }

            .entity_name {
                font-weight: bold;
                font-size: 14px;
                display: inline-block;
                max-width: 65%;
                overflow: hidden;
                text-overflow: ellipsis;
            }
            .entity_vehicle_number {
                max-width: 35%;
                overflow: hidden;
                text-overflow: ellipsis;
                float: right;
                font-size: 12px;
                font-weight: bold;
                vertical-align: middle;
                background-color: #1563ed;
                color: #fff;
                border-radius: 2px;
                padding: 2px 4px;
            }
            .entity_subtitle {
                margin-top: 6px;
                font-size: 12px;
                opacity: 0.8;
            }
        `;
    }

    getIcon(type) {
        switch (type) {
            case 'trash':
                return <FaTrash />;
            case 'menu':
                return <FaEllipsisV />;
            default:
                return <div>x</div>;
        }
    }

    renderOption() {
        if (!this.props.option) {
            return null;
        }

        return (
            <div
                className="entity_option_block"
                onClick={() => {
                    this.props.option.onClick();
                }}
            >
                {this.props.option.isDropdown ? (
                    <ItemOptionDropdown
                        options={this.props.option.dropdownOptions}
                    >
                        {this.getIcon(this.props.option.icon)}
                    </ItemOptionDropdown>
                ) : (
                    this.getIcon(this.props.option.icon)
                )}
            </div>
        );
    }

    render() {
        const entity_vehicle_number = this.props.entity.data
            ? this.props.entity.data['meta.vehicle_number']
            : null;
        return (
            <this.container
                small={this.props.small}
                className="entity_list_item"
                renderOption={this.props.option}
            >
                {this.props.entity.completed !== undefined ? (
                    <div
                        className={`entity_completed_block completed_${this.props.entity.completed}`}
                    ></div>
                ) : null}
                <div
                    className="entity_info_block"
                    onClick={() => {
                        if (this.props.onClickItem) {
                            this.props.onClickItem();
                        }
                    }}
                >
                    <p className="entity_name">{this.props.entity.name}</p>
                    {entity_vehicle_number ? (
                        <span className="entity_vehicle_number">
                            {entity_vehicle_number}
                        </span>
                    ) : null}
                    {this.props.entity.contractor_note ? (
                        <p
                            className="entity_subtitle"
                            onMouseEnter={() => {
                                this.setState({ contractor_note_hover: true });
                            }}
                            onMouseLeave={() => {
                                this.setState({ contractor_note_hover: false });
                            }}
                        >
                            <MdBuild /> {this.props.entity.contractor_note}
                        </p>
                    ) : null}
                    {this.state.contractor_note_hover ? (
                        <div className="note_hover contractor_note_hover">
                            <p className="note_hover_title">
                                {oh.translate('contractor')}
                            </p>
                            {this.props.entity.contractor_note}
                        </div>
                    ) : null}
                    {this.props.entity.admin_note ? (
                        <p
                            className="entity_subtitle"
                            onMouseEnter={() => {
                                this.setState({ admin_note_hover: true });
                            }}
                            onMouseLeave={() => {
                                this.setState({ admin_note_hover: false });
                            }}
                        >
                            <FaUserTie /> {this.props.entity.admin_note}
                        </p>
                    ) : null}
                    {this.state.admin_note_hover ? (
                        <div className="note_hover admin_note_hover">
                            <p className="note_hover_title">
                                {oh.translate('administrator')}
                            </p>
                            {this.props.entity.admin_note}
                        </div>
                    ) : null}
                </div>
                {this.renderOption()}
            </this.container>
        );
    }
}

export default EntityListItem;



// WEBPACK FOOTER //
// ./src/components/base/EntityListItem.jsx